import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountCard } from "@components/financialAccount/AccountCard/AccountCard";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";
import { SplitDetailRow } from "../views/splitDetailsViewConfig";

interface SplitFinancialAccountCellProps {
    row: { original: SplitDetailRow };
}

export const SplitFinancialAccountCell = memo(
    ({ row }: SplitFinancialAccountCellProps) => {
        const { financialAccountId } = row.original;

        const accounts = useFinancialAccounts();

        if (!financialAccountId) {
            return <ViewTableCell />;
        }

        const financialAccount = accounts?.find(
            (account) => account.id === financialAccountId,
        );

        if (!financialAccount) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell>
                <AccountCard
                    account={financialAccount}
                    showType={false}
                    iconSize="sm"
                />
            </ViewTableCell>
        );
    },
);

SplitFinancialAccountCell.displayName = "SplitFinancialAccountCell";
